<template>
<div class="pb-3 card shadow-sm">
<p v-if="isHeader" class="card-header text-left">ラリー詳細</p>
<table class="table mb-1 mx-auto text-secondary text-center table-responsive text-nowrap">
  <tbody>
    <tr>
      <td>&nbsp;</td>
      <td v-for="(h, idx) in hits.player"
        class="no-border" :key="idx">
        <span v-if="hits.isServe[idx]" class="font-half align-bottom">サーブ</span>
        <span v-else-if="hits.player.length - label == idx"
          class="font-half align-bottom">レシーブ</span>
        <span v-else class="font-half align-bottom">
          {{ idx - (hits.player.length - label - 2) }}球目
        </span>
      </td>
    </tr>
    <tr>
      <td>{{ gameInfo.player1Name }}</td>
      <td v-for="(h, idx) in hits.player"
        v-if="hits.player[idx] === 1"
        class="no-border" :key="idx"
        @click="editHits(idx)">
        <HitTableCell :isServe="hits.isServe[idx]" :hitPosition="hits.hitPosition[idx]"
          :hand="hits.hand[idx]" :hitStyle="hits.hitStyle[idx]" :course="hits.course[idx]"
          :inOutDetail="hits.inOutDetail[idx]" :inOut="hits.inOut[idx]" />
      </td>
      <td v-else></td>
    </tr>
    <tr>
      <td>{{ gameInfo.player2Name }}</td>
      <td v-for="(h, idx) in hits.player"
        v-if="hits.player[idx] === 2"
        class="no-border" :key="idx"
        @click="editHits(idx)">
        <HitTableCell :isServe="hits.isServe[idx]" :hitPosition="hits.hitPosition[idx]"
          :hand="hits.hand[idx]" :hitStyle="hits.hitStyle[idx]" :course="hits.course[idx]"
          :inOutDetail="hits.inOutDetail[idx]" :inOut="hits.inOut[idx]" />
      </td>
      <td v-else></td>
    </tr>
  </tbody>
</table>
</div>
</template>

<script>
import CmnConst from '@/lib/cmnConst';
import HitTableCell from '@/components/atoms/HitTableCell';

export default {
  name: 'hitsTable',
  props: ['hits', 'isHeader', 'label', 'gameInfo'],
  components: {
    HitTableCell,
  },
  data() {
    return {
      CmnConst,
    };
  },
  methods: {
    editHits(idx) {
      this.$emit('edit', idx);
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/molecules/HitsTable.vue